export default function(ngModule) {
    ngModule.factory('Template', function(BaseClass,$q, $http, BCRestable, Locales, $state) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Template(attributes) {
            _.assign(this,attributes);
            Object.defineProperty(this, 'localizedParts', {
                value: {},
                writable: true,
                enumerable: false
            });
            this.parseParts(this.parts);
        }
        Template.modelName = 'Template';


        BaseClass.apply(Template);

        Template.validates({
            name: {
                required: true
            },
            type: {
                required: true,
                inclusion: {
                    in: ['ticket', 'email']
                }
            },
            fallback_locale: {
                required: true,
                inclusion: {
                    in: _.map(Locales, 'code')
                }
            }
        });

        Template.create = function(name, fallbackLocale, type = 'ticket') {
            const adminBrowser = $state.transition && $state.transition.isActive() ? $state.transition.params().as : $state.params.as;
            const data = { name, fallback_locale: fallbackLocale, type };
            if(adminBrowser)
                data.company_id = adminBrowser;
            return $http.post('/template', data).then(response => {
                return Template.new(response.data);
            });
        };

        Template.prototype.getVariant = function(locale) {
            return $http.get(`/template/${this.guid}/${locale}`)
                .then(response => {
                    this.parseParts(response.data.parts);
                    return this;
                })
                .catch(error => this.broadcastAPIMessage(error));
        };

        Template.prototype.getExample = function(locale) {
            return $http.get(`/template/${this.guid}/${locale}/example`)
                .then(response => response.data)
                .catch(error => this.broadcastAPIMessage(error));
        };

        Template.prototype.getPart = function(part, locale) {
            // get requested part for requested locale, fallback to default locale
            let fallback = _.get(this.localizedParts, [this.fallback_locale, part]);
            return _.get(this.localizedParts, [locale, part], fallback);
        };

        Template.prototype.parseParts = function(parts) {
            _.forEach(parts, (part, type) => {
                if(!this.localizedParts[part.locale])
                    this.localizedParts[part.locale] = {};
                this.localizedParts[part.locale][type] = part;
            });
        };

        // We don't have a putVariant function because
        // uploading files using ajax is a bitch
        // so we can't do it on the model (yet)

        Template.prototype.deleteVariant = function(locale) {
            return $http.delete(`/template/${this.guid}/${locale}`)
                .then(response => this.broadcastAPIMessage(response))
                .catch(error => this.broadcastAPIMessage(error));
        };

        Template.prototype.link = function(ownerType, owner, belongsToType, belongsTo) {
            let params = _.compact([this.guid, ownerType, owner, belongsToType, belongsTo]).join('/');
            return $http.post('/template/' + params).then(
                res => this.broadcastAPIMessage(res),
                err => this.broadcastAPIMessage(err));
        };

        Template.prototype.unlink = function(ownerType, owner, belongsToType, belongsTo) {
            let params = _.compact([this.guid, ownerType, owner, belongsToType, belongsTo]).join('/');
            return $http.delete('/template/' + params).then(
                res => this.broadcastAPIMessage(res),
                err => this.broadcastAPIMessage(err));
        };

        Template.configureApi('/template/:guid', { guid: '@guid'});
        Template.prototype.toString = function() { return this.name; };

        return Template;
    });
}
